require.register("modules/m0x/a02/page-18-co/page-18-co", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_18co = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_18co;

  
});

